import src from "IMAGE";
export default { src, width: 1440, height: 800, blurDataURL: null, blurWidth: 0, blurHeight: 0 }
